import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const checkIsFavorite = async (productId: number, userId: string) => {
  const { data, error } = await supabase
    .from('products_favorite')
    .select('id')
    .eq('product', productId)
    .eq('user', userId)
    .maybeSingle();

  if (error) {
    throw new Error(`Error checking favorite status: ${error.message}`);
  }

  return !!data;
};

export default function useIsProductFavorite(productId: number, userId?: string) {
  return useQuery({
    queryKey: ['productFavorites', productId, userId],
    queryFn: () => checkIsFavorite(productId, userId!),
    enabled: !!productId && !!userId,
  });
} 